import React from 'react'
import { default as ReactCreatableSelect } from 'react-select/creatable'

const CreatableSelect = ({
  fieldKey,
  updateOptionValue,
  options,
  placeholder = '',
  isMulti = false,
  value,
  onChange
}) => {
  const getValue = () => {
    if (!value) return isMulti ? [] : null
    if (isMulti) {
      const vals = Array.isArray(value) ? value : [value]
      return vals.map(v => {
        const option = options.find(o => (typeof o === 'string' ? o === v : o.value === v))
        return typeof option === 'string' ? { value: option, label: option } : (option || { value: v, label: v })
      })
    }
    const option = options.find(o => (typeof o === 'string' ? o === value : o.value === value))
    return typeof option === 'string' ? { value: option, label: option } : (option || { value, label: value })
  }

  const handleChange = (newValue) => {
    const processedValue = isMulti
      ? (newValue ? newValue.map(item => item.value) : [])
      : (newValue ? newValue.value : '')

    if (onChange) {
      onChange(processedValue)
    }

    if (updateOptionValue) {
      updateOptionValue(processedValue, fieldKey)
    }
  }

  return (
    <ReactCreatableSelect
      isClearable
      isMulti={isMulti}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
      styles={{
        menuPortal: base => ({ ...base, zIndex: 10000 })
      }}
      value={getValue()}
      onChange={handleChange}
      options={options.map(opt => (typeof opt === 'string' ? { value: opt, label: opt } : opt))}
      placeholder={placeholder}
    />
  )
}

export default CreatableSelect